import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

import { useDomainTranslation } from "@/domain/_shared/i18n/use-domain-translation";
import { extractGraphQLErrorCode } from "@/lib/extract-graphql-error-code";
import { extractGraphQLErrorInfo } from "@/lib/extract-graphql-error-info";

import { DATA_REQUEST_DUE_DATE_IN_PAST } from "../../lib/data-request-error-codes";

import { useCreateDataRequestMutation } from "./use-create-data-request";

export function useCreateDataRequestWithFeedback() {
  const { t } = useDomainTranslation("data-request");
  const navigate = useNavigate();

  return useCreateDataRequestMutation({
    onCompleted: (dataRequest) => {
      toast.success(t("create.success"));
      navigate(`../${dataRequest.id}`);
    },
    onError: (error) => {
      if (extractGraphQLErrorCode(error) === DATA_REQUEST_DUE_DATE_IN_PAST) {
        toast.error(t("create.dueDateInPastTitle"), { description: t("create.dueDateInPastDescription") });
        return;
      }

      toast.error(t("create.error"), { description: extractGraphQLErrorInfo(error).userMessage });
    },
  });
}
